import {
  LOAD_DATA_FULL_SUCCESS,
  LOAD_INIT_DATA_SUCCESS,
} from 'actions/api-actions';
import {
  getDynamicAndStaticData,
  isExpiredTrip,
  isInvalidTrip,
} from 'common/utils/trip';
import Duck from 'extensible-duck';

const initialState = {
  trackingSource: '',
  trackingPageType: '',
  orderId: '',
};

export default new Duck({
  namespace: 'ge-delivery',
  store: 'instrumentation',
  initialState,
  types: ['UPDATE_TRACKING_INFO'],
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.UPDATE_TRACKING_INFO: {
        const {
          orderId,
          trackingPageType,
          trackingSource,
          isExpired,
        } = action.data;
        return {
          ...state,
          trackingSource,
          trackingPageType,
          orderId,
          isExpired,
        };
      }

      case LOAD_INIT_DATA_SUCCESS:
      case LOAD_DATA_FULL_SUCCESS: {
        const { data } = action;

        if (isInvalidTrip(data) || isExpiredTrip(data)) return state;
        const { webTrackingDetails } = data;

        const { staticData } = getDynamicAndStaticData(webTrackingDetails[0]);

        return {
          ...state,
          orderId: staticData.orderID,
        };
      }

      default:
        return state;
    }
  },
  selectors: duck => ({
    instrumentation: state => state[duck.store],
  }),
  creators: duck => ({
    updateTrackingInfo: data => ({
      type: duck.types.UPDATE_TRACKING_INFO,
      data,
    }),
  }),
});
